export const boxFlexDirection = { xs: 'column', sm: 'row' } as const;
